import React, { useEffect, useRef } from "react";
import { useUser } from "../shared/UserContext";
import SidebarNav from "./SidebarNav";
import "./Sidebar.css";

// The off-canvas navigation drawer for phones/small tablets. Rendered globally
// (in AppShell) for signed-in teachers so the hamburger menu works on every
// page — including the full-width daily screens (Attendance, Sign Out, etc.)
// that don't use the desktop AuthenticatedLayout sidebar.
//
// The drawer itself is display:none above the tablet breakpoint; on desktop the
// static in-flow Sidebar is used instead. Toggled by `mobileNavOpen` from the
// navbar hamburger.
const MobileDrawer = () => {
  const { mobileNavOpen, setMobileNavOpen } = useUser();
  const drawerRef = useRef(null);
  const closeDrawer = () => setMobileNavOpen(false);

  // Lock the page behind the drawer so touch scrolling stays inside the drawer
  // (and the background doesn't scroll away underneath it). Also close on Esc.
  // And always (re)open the drawer scrolled to the top, not wherever it was left.
  useEffect(() => {
    document.body.classList.toggle("drawer-open", mobileNavOpen);
    if (mobileNavOpen && drawerRef.current) drawerRef.current.scrollTop = 0;
    const onKey = (e) => e.key === "Escape" && setMobileNavOpen(false);
    if (mobileNavOpen) window.addEventListener("keydown", onKey);
    return () => {
      document.body.classList.remove("drawer-open");
      window.removeEventListener("keydown", onKey);
    };
  }, [mobileNavOpen, setMobileNavOpen]);

  return (
    <>
      <div
        className={`sidebar-backdrop ${mobileNavOpen ? "open" : ""}`}
        onClick={closeDrawer}
        aria-hidden="true"
      />
      <div
        ref={drawerRef}
        className={`mobile-drawer ${mobileNavOpen ? "open" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-label="Menu"
      >
        <button
          type="button"
          className="sidebar-close"
          aria-label="Close menu"
          onClick={closeDrawer}
        >
          &times;
        </button>
        <SidebarNav onNavigate={closeDrawer} />
      </div>
    </>
  );
};

export default MobileDrawer;
